import React, { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { ImportFileOutputData } from '#/graphql/types';
import SuccessModalBase from '../base/SuccessModalBase';

interface CapitalNeedSuccessModalProps {
  visible: boolean;
  onHiding: () => void;
  importResult: ImportFileOutputData | null;
}

const CapitalNeedSuccessModal: React.FC<CapitalNeedSuccessModalProps> = ({
  visible,
  onHiding,
  importResult,
}) => {
  const navigate = useNavigate();

  const redirectToAssetList = useCallback(() => {
    onHiding();
    navigate('/assets/list');
  }, [onHiding, navigate]);

  return (
    <SuccessModalBase
      visible={visible}
      onHiding={onHiding}
      importResult={importResult}
      entityRecordsLabelLower="capital need records"
      entityPluralLabelLower="capital needs"
      onRedirect={redirectToAssetList}
    />
  );
};

export default CapitalNeedSuccessModal;
